import accounting from 'accounting'
import { externalUrl } from '../externalUrl'

const Filters = {
  install(Vue) {
    Vue.filter('nl2br', (value) => String(value).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2'))

    Vue.filter('externalUrl', (url) => externalUrl(url))

    Vue.filter('dollars', (value, precision = 2) => {
      return accounting.formatMoney(value, '$', precision)
    })
  },
}

export default Filters
